import React from 'react';
import { motion } from 'framer-motion';
import { Package, Check } from 'lucide-react';
export function ProductReveal() {
  const includes = ['Protocolos de evaluación profesional', 'Planillas listas para usar', 'Sistemas de seguimiento clínico', 'Métodos organizados y replicables', 'Estructuras aplicables desde el día 1'];
  return <section className="py-10 px-4 bg-slate-900 border-t border-slate-800" data-id="element-89">
      <div className="max-w-3xl mx-auto" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-91">
          <h2 className="text-3xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-teal-200 mb-2" data-id="element-92">
            🔥 KIT ORTOPEDISTA PRO
          </h2>
          <p className="text-base text-slate-300" data-id="element-93">
            Un sistema profesional. No es teoría.{' '}
            <span className="text-amber-400 font-bold" data-id="element-94">
              Es implementación directa.
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-950 p-5 md:p-8 rounded-2xl border border-slate-800" data-id="element-95">
          <div className="flex items-center gap-3 mb-4" data-id="element-96">
            <Package className="w-7 h-7 text-teal-400" data-id="element-97" />
            <h3 className="text-xl font-bold text-white" data-id="element-98">¿Qué incluye?</h3>
          </div>
          <p className="text-slate-300 text-sm mb-4" data-id="element-99">
            Un sistema completo dividido en 10 tomos prácticos:
          </p>
          <ul className="space-y-3 mb-5" data-id="element-100">
            {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-101">
                <Check className="w-5 h-5 text-teal-500 flex-shrink-0" data-id="element-102" />
                <span className="text-slate-200 text-sm" data-id="element-103">{item}</span>
              </li>)}
          </ul>
          <p className="font-bold text-amber-400 bg-amber-950/30 p-3 rounded-lg border border-amber-900/50 text-sm" data-id="element-104">
            👉 Todo pensado para que no tengas que crear nada desde cero.
          </p>
        </motion.div>
      </div>
    </section>;
}